<template>
  <div>
    <div class="title"><div>猩号app版本更新</div></div>
    <div>
      <el-button style="margin:20px" icon="el-icon-plus" @click="updataApp();">
        新增版本
      </el-button>
    </div>
    <el-table :data="list">
      <el-table-column label="编号" type="index"> </el-table-column>
      <el-table-column prop="version" label="版本号"> </el-table-column>
      <el-table-column prop="platform" label="平台类型"> </el-table-column>
      <el-table-column prop="type" label="版本类型"> </el-table-column>
      <el-table-column prop="url" label="版本链接"> </el-table-column>
      <el-table-column prop="descrbe" label="版本描述"> </el-table-column>
      <el-table-column prop="" label="操作">
        <template slot-scope="{ row }">
          <div>
            <el-button @click="changeform(row);"> 修改 </el-button>
            <el-button @click="toDelete(row);"> 删除 </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="ifsee" title="版本">
      <el-form label-width="80px" :model="form">
        <el-form-item label="版本号">
          <el-input v-model="form.version"></el-input>
        </el-form-item>
        <el-form-item label="平台类型">
          <el-select v-model="form.platform">
            <el-option value="iPhone" label="iPhone"> </el-option>
            <el-option value="HUAWEI" label="HUAWEI"> </el-option>
            <el-option value="Xiaomi" label="Xiaomi"> </el-option>
            <el-option value="OPPO" label="OPPO"> </el-option>
            <el-option value="vivo" label="vivo"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本类型">
          <el-select v-model="form.type">
            <el-option value="1" label="热更新"> </el-option>
            <el-option value="2" label="版本更新"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本链接">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item label="版本描述">
          <el-input type="textarea" v-model="form.descrbe"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ifsee = false;">取 消</el-button>
        <el-button type="primary" @click="setUpdataApp();">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="ifdelete" title="版本删除">
      <div slot="footer" class="dialog-footer">
        <el-button @click="ifdelete = false;">取 消</el-button>
        <el-button type="primary" @click="deleteApp();">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        version: "", //版本号
        platform: "", //平台类型，ios或者android
        type: "", //版本类型，1(热更新),2(版本更新)
        url: "", //版本的网址
        descrbe: "" //版本描述
      },
      ifsee: false,
      list: [],
      ifdelete: false,
      version_id: ""
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    getlist() {
      this.$axios.get(this.$url_prefix + "xinghao/release/list").then(res => {
        console.log(res);
        this.list = res.data.data;
      });
    },
    updataApp() {
      this.type = "新增";
      this.ifsee = true;
    },
    setUpdataApp() {
      if (!this.form.version) {
        this.$message("请填写版本号");
        return;
      }
      if (!this.form.platform) {
        this.$message("请选择你的平台类型");
        return;
      }
      if (!this.form.version) {
        this.$message("请选择你的版本类型");
        return;
      }
      if (!this.form.version) {
        this.$message("请填写版本地址");
        return;
      }
      if (!this.form.version) {
        this.$message("请填写版本描述");
        return;
      }
      let api = "xinghao/release/publish";
      if (this.type === "修改") {
        api = "xinghao/release/modify";
      }
      this.$axios.post(this.$url_prefix + api, this.form).then(res => {
        console.log(res);
        if (res.data.success) {
          this.form = {
            version: "", //版本号
            platform: "", //平台类型，ios或者android
            type: "", //版本类型，1(热更新),2(版本更新)
            url: "", //版本的网址
            descrbe: "" //版本描述
          };
          this.ifsee = false;
          this.getlist();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    changeform(row) {
      let form = row;
      this.form = form;
      this.type = "修改";
      this.ifsee = true;
    },
    toDelete(row) {
      this.ifdelete = true;
      this.version_id = row._id;
    },
    deleteApp() {
      if (!this.version_id) {
        return;
      }
      this.$axios
        .get(this.$url_prefix + "xinghao/release/delete", {
          params: {
            version_id: this.version_id
          }
        })
        .then(res => {
          console.log(res);
          this.ifdelete = false;
          this.getlist();
        });
    }
  }
};
</script>

<style>
.title {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/UpDataApp.vue